export default __webpack_public_path__ + "static/media/download_school_file.e2369556.svg";